<template>
    <form @submit.prevent="login" novalidate>
        <div
            v-if="errors.errorMessage()"
            v-html="errors.errorMessage()"
            class="form-error-message"
        ></div>
        <div
            v-if="successMessage"
            v-html="successMessage"
            class="form-success-message"
        ></div>
        {{ $trans('auth.login.email') }}
        <div class="form-group">
            <app-input
                :error="errors.get('email')"
                v-model="form.email"
                :placeholder="$trans('auth.login.email')"
            >
            </app-input>
        </div>

        <div class="form-group">
            <app-input
                :error="errors.get('password')"
                v-model="form.password"
                :type="passType"
                icon="eye"
                :icon-clickable="true"
                @click="togglePasswordType"
                :placeholder="$trans('auth.login.password')"
            >
            </app-input>
        </div>

        <div class="form-group flex-items submit-row">
            <div class="flex-item">
                <app-button
                    :loading="loading"
                    :disabled="!!(successMessage && successMessage.length)"
                    type="submit"
                    >{{ $trans("auth.login.login_btn") }}</app-button
                >
            </div>
            <div class="flex-item">
                <app-checkbox
                    v-model="form.remember_me"
                    :label="$trans('auth.login.remember_me')"
                ></app-checkbox>
            </div>
        </div>

        <div class="form-group flex-items">
            <a :href="app.links.forgot_password" class="forgot-password">{{
                $trans("auth.login.forgot_password")
            }}</a>
            <a :href="app.links.register" class="new-user">{{
                $trans("auth.login.new_user")
            }}</a>
        </div>

        <div class="separator"></div>

        <div class="form-group">
            <div
                class="agreement-text"
                v-html="$trans('auth.terms_text')"
            ></div>
        </div>
    </form>
</template>

<script>
export default {
    props: {
        isSpinToWin: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            errors: this.$api.errors(),
            loading: false,
            successMessage: false,
            passType: "password",
            form: {
                email: "",
                password: "",
                remember_me: false
            }
        };
    },
    methods: {
        togglePasswordType() {
            this.passType = this.passType == "password" ? "text" : "password";
        },
        async login() {
            this.loading = true;

            this.errors.clear();
            const response = await this.$api.post("auth/login", this.form);
            this.loading = false;

            if (response.hasErrors()) {
                this.errors = response.errors();
                return;
            }

            if (response.data().message) {
                this.successMessage = response.data().message;
            }

            if (response.data().redirect) {
                setTimeout(() => {
                    window.location.href = response.data().redirect;
                }, 2000);
            }
        }
    }
};
</script>
